import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';

import { StorageService } from '@app/core/services';

@Injectable({
  providedIn: 'root',
})
export class AssistantGuard implements CanActivate, CanLoad {
  constructor(
    private readonly storageService: StorageService,
    private router: Router,
  ) {}

  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.canOpenAssistant();
  }

  canLoad(): Observable<boolean> | Promise<boolean> | boolean {
    return this.canOpenAssistant();
  }

  private canOpenAssistant(): boolean {
    if (this.storageService.USER && this.storageService.CONFIG?.has_chatbot) {
      return true;
    }
    this.router.navigateByUrl('/');
    return false;
  }
}
